import { render, staticRenderFns } from "./BroadcastFormCompose.vue?vue&type=template&id=5acfa9b4&scoped=true&"
import script from "./BroadcastFormCompose.vue?vue&type=script&lang=ts&"
export * from "./BroadcastFormCompose.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastFormCompose.vue?vue&type=style&index=0&id=5acfa9b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acfa9b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VCol,VIcon,VRow,VSwitch,VTextField})
